import React, { FC, memo, useMemo } from "react";

const TailwindCssSafeList: FC = () => {

    const shouldInclude = useMemo(() => process.env.NODE_ENV === "development", []);


    const renderSafeList = () => (
        <div className="hidden">
            <div className="hidden text-brand-50"></div>
            <div className="hidden text-brand-100"></div>
            <div className="hidden text-brand-200"></div>
            <div className="hidden text-brand-300"></div>
            <div className="hidden text-brand-400"></div>
            <div className="hidden text-brand-500"></div>
            <div className="hidden text-brand-600"></div>
            <div className="hidden text-brand-700"></div>
            <div className="hidden text-brand-800"></div>
            <div className="hidden text-brand-900"></div>
            <div className="hidden text-gray-50"></div>
            <div className="hidden text-gray-100"></div>
            <div className="hidden text-gray-200"></div>
            <div className="hidden text-gray-300"></div>
            <div className="hidden text-gray-400"></div>
            <div className="hidden text-gray-500"></div>
            <div className="hidden text-gray-600"></div>
            <div className="hidden text-gray-700"></div>
            <div className="hidden text-gray-800"></div>
            <div className="hidden text-gray-900"></div>
            <div className="hidden text-navy-50"></div>
            <div className="hidden text-navy-100"></div>
            <div className="hidden text-navy-200"></div>
            <div className="hidden text-navy-300"></div>
            <div className="hidden text-navy-400"></div>
            <div className="hidden text-navy-500"></div>
            <div className="hidden text-navy-600"></div>
            <div className="hidden text-navy-700"></div>
            <div className="hidden text-navy-800"></div>
            <div className="hidden text-navy-900"></div>
            <div className="hidden text-red-50"></div>
            <div className="hidden text-red-100"></div>
            <div className="hidden text-red-200"></div>
            <div className="hidden text-red-300"></div>
            <div className="hidden text-red-400"></div>
            <div className="hidden text-red-500"></div>
            <div className="hidden text-red-600"></div>
            <div className="hidden text-red-700"></div>
            <div className="hidden text-red-800"></div>
            <div className="hidden text-red-900"></div>
            <div className="hidden text-orange-50"></div>
            <div className="hidden text-orange-100"></div>
            <div className="hidden text-orange-200"></div>
            <div className="hidden text-orange-300"></div>
            <div className="hidden text-orange-400"></div>
            <div className="hidden text-orange-500"></div>
            <div className="hidden text-orange-600"></div>
            <div className="hidden text-orange-700"></div>
            <div className="hidden text-orange-800"></div>
            <div className="hidden text-orange-900"></div>
            <div className="hidden text-amber-50"></div>
            <div className="hidden text-amber-100"></div>
            <div className="hidden text-amber-200"></div>
            <div className="hidden text-amber-300"></div>
            <div className="hidden text-amber-400"></div>
            <div className="hidden text-amber-500"></div>
            <div className="hidden text-amber-600"></div>
            <div className="hidden text-amber-700"></div>
            <div className="hidden text-amber-800"></div>
            <div className="hidden text-amber-900"></div>
            <div className="hidden text-yellow-50"></div>
            <div className="hidden text-yellow-100"></div>
            <div className="hidden text-yellow-200"></div>
            <div className="hidden text-yellow-300"></div>
            <div className="hidden text-yellow-400"></div>
            <div className="hidden text-yellow-500"></div>
            <div className="hidden text-yellow-600"></div>
            <div className="hidden text-yellow-700"></div>
            <div className="hidden text-yellow-800"></div>
            <div className="hidden text-yellow-900"></div>
            <div className="hidden text-lime-50"></div>
            <div className="hidden text-lime-100"></div>
            <div className="hidden text-lime-200"></div>
            <div className="hidden text-lime-300"></div>
            <div className="hidden text-lime-400"></div>
            <div className="hidden text-lime-500"></div>
            <div className="hidden text-lime-600"></div>
            <div className="hidden text-lime-700"></div>
            <div className="hidden text-lime-800"></div>
            <div className="hidden text-lime-900"></div>
            <div className="hidden text-green-50"></div>
            <div className="hidden text-green-100"></div>
            <div className="hidden text-green-200"></div>
            <div className="hidden text-green-300"></div>
            <div className="hidden text-green-400"></div>
            <div className="hidden text-green-500"></div>
            <div className="hidden text-green-600"></div>
            <div className="hidden text-green-700"></div>
            <div className="hidden text-green-800"></div>
            <div className="hidden text-green-900"></div>
            <div className="hidden text-teal-50"></div>
            <div className="hidden text-teal-100"></div>
            <div className="hidden text-teal-200"></div>
            <div className="hidden text-teal-300"></div>
            <div className="hidden text-teal-400"></div>
            <div className="hidden text-teal-500"></div>
            <div className="hidden text-teal-600"></div>
            <div className="hidden text-teal-700"></div>
            <div className="hidden text-teal-800"></div>
            <div className="hidden text-teal-900"></div>
            <div className="hidden text-cyan-50"></div>
            <div className="hidden text-cyan-100"></div>
            <div className="hidden text-cyan-200"></div>
            <div className="hidden text-cyan-300"></div>
            <div className="hidden text-cyan-400"></div>
            <div className="hidden text-cyan-500"></div>
            <div className="hidden text-cyan-600"></div>
            <div className="hidden text-cyan-700"></div>
            <div className="hidden text-cyan-800"></div>
            <div className="hidden text-cyan-900"></div>
            <div className="hidden text-blue-50"></div>
            <div className="hidden text-blue-100"></div>
            <div className="hidden text-blue-200"></div>
            <div className="hidden text-blue-300"></div>
            <div className="hidden text-blue-400"></div>
            <div className="hidden text-blue-500"></div>
            <div className="hidden text-blue-600"></div>
            <div className="hidden text-blue-700"></div>
            <div className="hidden text-blue-800"></div>
            <div className="hidden text-blue-900"></div>
            <div className="hidden text-indigo-50"></div>
            <div className="hidden text-indigo-100"></div>
            <div className="hidden text-indigo-200"></div>
            <div className="hidden text-indigo-300"></div>
            <div className="hidden text-indigo-400"></div>
            <div className="hidden text-indigo-500"></div>
            <div className="hidden text-indigo-600"></div>
            <div className="hidden text-indigo-700"></div>
            <div className="hidden text-indigo-800"></div>
            <div className="hidden text-indigo-900"></div>
            <div className="hidden text-purple-50"></div>
            <div className="hidden text-purple-100"></div>
            <div className="hidden text-purple-200"></div>
            <div className="hidden text-purple-300"></div>
            <div className="hidden text-purple-400"></div>
            <div className="hidden text-purple-500"></div>
            <div className="hidden text-purple-600"></div>
            <div className="hidden text-purple-700"></div>
            <div className="hidden text-purple-800"></div>
            <div className="hidden text-purple-900"></div>
            <div className="hidden text-pink-50"></div>
            <div className="hidden text-pink-100"></div>
            <div className="hidden text-pink-200"></div>
            <div className="hidden text-pink-300"></div>
            <div className="hidden text-pink-400"></div>
            <div className="hidden text-pink-500"></div>
            <div className="hidden text-pink-600"></div>
            <div className="hidden text-pink-700"></div>
            <div className="hidden text-pink-800"></div>
            <div className="hidden text-pink-900"></div>
            <div className="hidden border-brand-50"></div>
            <div className="hidden border-brand-100"></div>
            <div className="hidden border-brand-200"></div>
            <div className="hidden border-brand-300"></div>
            <div className="hidden border-brand-400"></div>
            <div className="hidden border-brand-500"></div>
            <div className="hidden border-brand-600"></div>
            <div className="hidden border-brand-700"></div>
            <div className="hidden border-brand-800"></div>
            <div className="hidden border-brand-900"></div>
            <div className="hidden border-gray-50"></div>
            <div className="hidden border-gray-100"></div>
            <div className="hidden border-gray-200"></div>
            <div className="hidden border-gray-300"></div>
            <div className="hidden border-gray-400"></div>
            <div className="hidden border-gray-500"></div>
            <div className="hidden border-gray-600"></div>
            <div className="hidden border-gray-700"></div>
            <div className="hidden border-gray-800"></div>
            <div className="hidden border-gray-900"></div>
            <div className="hidden border-navy-50"></div>
            <div className="hidden border-navy-100"></div>
            <div className="hidden border-navy-200"></div>
            <div className="hidden border-navy-300"></div>
            <div className="hidden border-navy-400"></div>
            <div className="hidden border-navy-500"></div>
            <div className="hidden border-navy-600"></div>
            <div className="hidden border-navy-700"></div>
            <div className="hidden border-navy-800"></div>
            <div className="hidden border-navy-900"></div>
            <div className="hidden border-red-50"></div>
            <div className="hidden border-red-100"></div>
            <div className="hidden border-red-200"></div>
            <div className="hidden border-red-300"></div>
            <div className="hidden border-red-400"></div>
            <div className="hidden border-red-500"></div>
            <div className="hidden border-red-600"></div>
            <div className="hidden border-red-700"></div>
            <div className="hidden border-red-800"></div>
            <div className="hidden border-red-900"></div>
            <div className="hidden border-orange-50"></div>
            <div className="hidden border-orange-100"></div>
            <div className="hidden border-orange-200"></div>
            <div className="hidden border-orange-300"></div>
            <div className="hidden border-orange-400"></div>
            <div className="hidden border-orange-500"></div>
            <div className="hidden border-orange-600"></div>
            <div className="hidden border-orange-700"></div>
            <div className="hidden border-orange-800"></div>
            <div className="hidden border-orange-900"></div>
            <div className="hidden border-amber-50"></div>
            <div className="hidden border-amber-100"></div>
            <div className="hidden border-amber-200"></div>
            <div className="hidden border-amber-300"></div>
            <div className="hidden border-amber-400"></div>
            <div className="hidden border-amber-500"></div>
            <div className="hidden border-amber-600"></div>
            <div className="hidden border-amber-700"></div>
            <div className="hidden border-amber-800"></div>
            <div className="hidden border-amber-900"></div>
            <div className="hidden border-yellow-50"></div>
            <div className="hidden border-yellow-100"></div>
            <div className="hidden border-yellow-200"></div>
            <div className="hidden border-yellow-300"></div>
            <div className="hidden border-yellow-400"></div>
            <div className="hidden border-yellow-500"></div>
            <div className="hidden border-yellow-600"></div>
            <div className="hidden border-yellow-700"></div>
            <div className="hidden border-yellow-800"></div>
            <div className="hidden border-yellow-900"></div>
            <div className="hidden border-lime-50"></div>
            <div className="hidden border-lime-100"></div>
            <div className="hidden border-lime-200"></div>
            <div className="hidden border-lime-300"></div>
            <div className="hidden border-lime-400"></div>
            <div className="hidden border-lime-500"></div>
            <div className="hidden border-lime-600"></div>
            <div className="hidden border-lime-700"></div>
            <div className="hidden border-lime-800"></div>
            <div className="hidden border-lime-900"></div>
            <div className="hidden border-green-50"></div>
            <div className="hidden border-green-100"></div>
            <div className="hidden border-green-200"></div>
            <div className="hidden border-green-300"></div>
            <div className="hidden border-green-400"></div>
            <div className="hidden border-green-500"></div>
            <div className="hidden border-green-600"></div>
            <div className="hidden border-green-700"></div>
            <div className="hidden border-green-800"></div>
            <div className="hidden border-green-900"></div>
            <div className="hidden border-teal-50"></div>
            <div className="hidden border-teal-100"></div>
            <div className="hidden border-teal-200"></div>
            <div className="hidden border-teal-300"></div>
            <div className="hidden border-teal-400"></div>
            <div className="hidden border-teal-500"></div>
            <div className="hidden border-teal-600"></div>
            <div className="hidden border-teal-700"></div>
            <div className="hidden border-teal-800"></div>
            <div className="hidden border-teal-900"></div>
            <div className="hidden border-cyan-50"></div>
            <div className="hidden border-cyan-100"></div>
            <div className="hidden border-cyan-200"></div>
            <div className="hidden border-cyan-300"></div>
            <div className="hidden border-cyan-400"></div>
            <div className="hidden border-cyan-500"></div>
            <div className="hidden border-cyan-600"></div>
            <div className="hidden border-cyan-700"></div>
            <div className="hidden border-cyan-800"></div>
            <div className="hidden border-cyan-900"></div>
            <div className="hidden border-blue-50"></div>
            <div className="hidden border-blue-100"></div>
            <div className="hidden border-blue-200"></div>
            <div className="hidden border-blue-300"></div>
            <div className="hidden border-blue-400"></div>
            <div className="hidden border-blue-500"></div>
            <div className="hidden border-blue-600"></div>
            <div className="hidden border-blue-700"></div>
            <div className="hidden border-blue-800"></div>
            <div className="hidden border-blue-900"></div>
            <div className="hidden border-indigo-50"></div>
            <div className="hidden border-indigo-100"></div>
            <div className="hidden border-indigo-200"></div>
            <div className="hidden border-indigo-300"></div>
            <div className="hidden border-indigo-400"></div>
            <div className="hidden border-indigo-500"></div>
            <div className="hidden border-indigo-600"></div>
            <div className="hidden border-indigo-700"></div>
            <div className="hidden border-indigo-800"></div>
            <div className="hidden border-indigo-900"></div>
            <div className="hidden border-purple-50"></div>
            <div className="hidden border-purple-100"></div>
            <div className="hidden border-purple-200"></div>
            <div className="hidden border-purple-300"></div>
            <div className="hidden border-purple-400"></div>
            <div className="hidden border-purple-500"></div>
            <div className="hidden border-purple-600"></div>
            <div className="hidden border-purple-700"></div>
            <div className="hidden border-purple-800"></div>
            <div className="hidden border-purple-900"></div>
            <div className="hidden border-pink-50"></div>
            <div className="hidden border-pink-100"></div>
            <div className="hidden border-pink-200"></div>
            <div className="hidden border-pink-300"></div>
            <div className="hidden border-pink-400"></div>
            <div className="hidden border-pink-500"></div>
            <div className="hidden border-pink-600"></div>
            <div className="hidden border-pink-700"></div>
            <div className="hidden border-pink-800"></div>
            <div className="hidden border-pink-900"></div>
            <div className="hidden bg-brand-50"></div>
            <div className="hidden bg-brand-100"></div>
            <div className="hidden bg-brand-200"></div>
            <div className="hidden bg-brand-300"></div>
            <div className="hidden bg-brand-400"></div>
            <div className="hidden bg-brand-500"></div>
            <div className="hidden bg-brand-600"></div>
            <div className="hidden bg-brand-700"></div>
            <div className="hidden bg-brand-800"></div>
            <div className="hidden bg-brand-900"></div>
            <div className="hidden bg-gray-50"></div>
            <div className="hidden bg-gray-100"></div>
            <div className="hidden bg-gray-200"></div>
            <div className="hidden bg-gray-300"></div>
            <div className="hidden bg-gray-400"></div>
            <div className="hidden bg-gray-500"></div>
            <div className="hidden bg-gray-600"></div>
            <div className="hidden bg-gray-700"></div>
            <div className="hidden bg-gray-800"></div>
            <div className="hidden bg-gray-900"></div>
            <div className="hidden bg-navy-50"></div>
            <div className="hidden bg-navy-100"></div>
            <div className="hidden bg-navy-200"></div>
            <div className="hidden bg-navy-300"></div>
            <div className="hidden bg-navy-400"></div>
            <div className="hidden bg-navy-500"></div>
            <div className="hidden bg-navy-600"></div>
            <div className="hidden bg-navy-700"></div>
            <div className="hidden bg-navy-800"></div>
            <div className="hidden bg-navy-900"></div>
            <div className="hidden bg-red-50"></div>
            <div className="hidden bg-red-100"></div>
            <div className="hidden bg-red-200"></div>
            <div className="hidden bg-red-300"></div>
            <div className="hidden bg-red-400"></div>
            <div className="hidden bg-red-500"></div>
            <div className="hidden bg-red-600"></div>
            <div className="hidden bg-red-700"></div>
            <div className="hidden bg-red-800"></div>
            <div className="hidden bg-red-900"></div>
            <div className="hidden bg-orange-50"></div>
            <div className="hidden bg-orange-100"></div>
            <div className="hidden bg-orange-200"></div>
            <div className="hidden bg-orange-300"></div>
            <div className="hidden bg-orange-400"></div>
            <div className="hidden bg-orange-500"></div>
            <div className="hidden bg-orange-600"></div>
            <div className="hidden bg-orange-700"></div>
            <div className="hidden bg-orange-800"></div>
            <div className="hidden bg-orange-900"></div>
            <div className="hidden bg-amber-50"></div>
            <div className="hidden bg-amber-100"></div>
            <div className="hidden bg-amber-200"></div>
            <div className="hidden bg-amber-300"></div>
            <div className="hidden bg-amber-400"></div>
            <div className="hidden bg-amber-500"></div>
            <div className="hidden bg-amber-600"></div>
            <div className="hidden bg-amber-700"></div>
            <div className="hidden bg-amber-800"></div>
            <div className="hidden bg-amber-900"></div>
            <div className="hidden bg-yellow-50"></div>
            <div className="hidden bg-yellow-100"></div>
            <div className="hidden bg-yellow-200"></div>
            <div className="hidden bg-yellow-300"></div>
            <div className="hidden bg-yellow-400"></div>
            <div className="hidden bg-yellow-500"></div>
            <div className="hidden bg-yellow-600"></div>
            <div className="hidden bg-yellow-700"></div>
            <div className="hidden bg-yellow-800"></div>
            <div className="hidden bg-yellow-900"></div>
            <div className="hidden bg-lime-50"></div>
            <div className="hidden bg-lime-100"></div>
            <div className="hidden bg-lime-200"></div>
            <div className="hidden bg-lime-300"></div>
            <div className="hidden bg-lime-400"></div>
            <div className="hidden bg-lime-500"></div>
            <div className="hidden bg-lime-600"></div>
            <div className="hidden bg-lime-700"></div>
            <div className="hidden bg-lime-800"></div>
            <div className="hidden bg-lime-900"></div>
            <div className="hidden bg-green-50"></div>
            <div className="hidden bg-green-100"></div>
            <div className="hidden bg-green-200"></div>
            <div className="hidden bg-green-300"></div>
            <div className="hidden bg-green-400"></div>
            <div className="hidden bg-green-500"></div>
            <div className="hidden bg-green-600"></div>
            <div className="hidden bg-green-700"></div>
            <div className="hidden bg-green-800"></div>
            <div className="hidden bg-green-900"></div>
            <div className="hidden bg-teal-50"></div>
            <div className="hidden bg-teal-100"></div>
            <div className="hidden bg-teal-200"></div>
            <div className="hidden bg-teal-300"></div>
            <div className="hidden bg-teal-400"></div>
            <div className="hidden bg-teal-500"></div>
            <div className="hidden bg-teal-600"></div>
            <div className="hidden bg-teal-700"></div>
            <div className="hidden bg-teal-800"></div>
            <div className="hidden bg-teal-900"></div>
            <div className="hidden bg-cyan-50"></div>
            <div className="hidden bg-cyan-100"></div>
            <div className="hidden bg-cyan-200"></div>
            <div className="hidden bg-cyan-300"></div>
            <div className="hidden bg-cyan-400"></div>
            <div className="hidden bg-cyan-500"></div>
            <div className="hidden bg-cyan-600"></div>
            <div className="hidden bg-cyan-700"></div>
            <div className="hidden bg-cyan-800"></div>
            <div className="hidden bg-cyan-900"></div>
            <div className="hidden bg-blue-50"></div>
            <div className="hidden bg-blue-100"></div>
            <div className="hidden bg-blue-200"></div>
            <div className="hidden bg-blue-300"></div>
            <div className="hidden bg-blue-400"></div>
            <div className="hidden bg-blue-500"></div>
            <div className="hidden bg-blue-600"></div>
            <div className="hidden bg-blue-700"></div>
            <div className="hidden bg-blue-800"></div>
            <div className="hidden bg-blue-900"></div>
            <div className="hidden bg-indigo-50"></div>
            <div className="hidden bg-indigo-100"></div>
            <div className="hidden bg-indigo-200"></div>
            <div className="hidden bg-indigo-300"></div>
            <div className="hidden bg-indigo-400"></div>
            <div className="hidden bg-indigo-500"></div>
            <div className="hidden bg-indigo-600"></div>
            <div className="hidden bg-indigo-700"></div>
            <div className="hidden bg-indigo-800"></div>
            <div className="hidden bg-indigo-900"></div>
            <div className="hidden bg-purple-50"></div>
            <div className="hidden bg-purple-100"></div>
            <div className="hidden bg-purple-200"></div>
            <div className="hidden bg-purple-300"></div>
            <div className="hidden bg-purple-400"></div>
            <div className="hidden bg-purple-500"></div>
            <div className="hidden bg-purple-600"></div>
            <div className="hidden bg-purple-700"></div>
            <div className="hidden bg-purple-800"></div>
            <div className="hidden bg-purple-900"></div>
            <div className="hidden bg-pink-50"></div>
            <div className="hidden bg-pink-100"></div>
            <div className="hidden bg-pink-200"></div>
            <div className="hidden bg-pink-300"></div>
            <div className="hidden bg-pink-400"></div>
            <div className="hidden bg-pink-500"></div>
            <div className="hidden bg-pink-600"></div>
            <div className="hidden bg-pink-700"></div>
            <div className="hidden bg-pink-800"></div>
            <div className="hidden bg-pink-900"></div>
            <div className="hidden hover:text-brand-50"></div>
            <div className="hidden hover:text-brand-100"></div>
            <div className="hidden hover:text-brand-200"></div>
            <div className="hidden hover:text-brand-300"></div>
            <div className="hidden hover:text-brand-400"></div>
            <div className="hidden hover:text-brand-500"></div>
            <div className="hidden hover:text-brand-600"></div>
            <div className="hidden hover:text-brand-700"></div>
            <div className="hidden hover:text-brand-800"></div>
            <div className="hidden hover:text-brand-900"></div>
            <div className="hidden hover:text-gray-50"></div>
            <div className="hidden hover:text-gray-100"></div>
            <div className="hidden hover:text-gray-200"></div>
            <div className="hidden hover:text-gray-300"></div>
            <div className="hidden hover:text-gray-400"></div>
            <div className="hidden hover:text-gray-500"></div>
            <div className="hidden hover:text-gray-600"></div>
            <div className="hidden hover:text-gray-700"></div>
            <div className="hidden hover:text-gray-800"></div>
            <div className="hidden hover:text-gray-900"></div>
            <div className="hidden hover:text-navy-50"></div>
            <div className="hidden hover:text-navy-100"></div>
            <div className="hidden hover:text-navy-200"></div>
            <div className="hidden hover:text-navy-300"></div>
            <div className="hidden hover:text-navy-400"></div>
            <div className="hidden hover:text-navy-500"></div>
            <div className="hidden hover:text-navy-600"></div>
            <div className="hidden hover:text-navy-700"></div>
            <div className="hidden hover:text-navy-800"></div>
            <div className="hidden hover:text-navy-900"></div>
            <div className="hidden hover:text-red-50"></div>
            <div className="hidden hover:text-red-100"></div>
            <div className="hidden hover:text-red-200"></div>
            <div className="hidden hover:text-red-300"></div>
            <div className="hidden hover:text-red-400"></div>
            <div className="hidden hover:text-red-500"></div>
            <div className="hidden hover:text-red-600"></div>
            <div className="hidden hover:text-red-700"></div>
            <div className="hidden hover:text-red-800"></div>
            <div className="hidden hover:text-red-900"></div>
            <div className="hidden hover:text-orange-50"></div>
            <div className="hidden hover:text-orange-100"></div>
            <div className="hidden hover:text-orange-200"></div>
            <div className="hidden hover:text-orange-300"></div>
            <div className="hidden hover:text-orange-400"></div>
            <div className="hidden hover:text-orange-500"></div>
            <div className="hidden hover:text-orange-600"></div>
            <div className="hidden hover:text-orange-700"></div>
            <div className="hidden hover:text-orange-800"></div>
            <div className="hidden hover:text-orange-900"></div>
            <div className="hidden hover:text-amber-50"></div>
            <div className="hidden hover:text-amber-100"></div>
            <div className="hidden hover:text-amber-200"></div>
            <div className="hidden hover:text-amber-300"></div>
            <div className="hidden hover:text-amber-400"></div>
            <div className="hidden hover:text-amber-500"></div>
            <div className="hidden hover:text-amber-600"></div>
            <div className="hidden hover:text-amber-700"></div>
            <div className="hidden hover:text-amber-800"></div>
            <div className="hidden hover:text-amber-900"></div>
            <div className="hidden hover:text-yellow-50"></div>
            <div className="hidden hover:text-yellow-100"></div>
            <div className="hidden hover:text-yellow-200"></div>
            <div className="hidden hover:text-yellow-300"></div>
            <div className="hidden hover:text-yellow-400"></div>
            <div className="hidden hover:text-yellow-500"></div>
            <div className="hidden hover:text-yellow-600"></div>
            <div className="hidden hover:text-yellow-700"></div>
            <div className="hidden hover:text-yellow-800"></div>
            <div className="hidden hover:text-yellow-900"></div>
            <div className="hidden hover:text-lime-50"></div>
            <div className="hidden hover:text-lime-100"></div>
            <div className="hidden hover:text-lime-200"></div>
            <div className="hidden hover:text-lime-300"></div>
            <div className="hidden hover:text-lime-400"></div>
            <div className="hidden hover:text-lime-500"></div>
            <div className="hidden hover:text-lime-600"></div>
            <div className="hidden hover:text-lime-700"></div>
            <div className="hidden hover:text-lime-800"></div>
            <div className="hidden hover:text-lime-900"></div>
            <div className="hidden hover:text-green-50"></div>
            <div className="hidden hover:text-green-100"></div>
            <div className="hidden hover:text-green-200"></div>
            <div className="hidden hover:text-green-300"></div>
            <div className="hidden hover:text-green-400"></div>
            <div className="hidden hover:text-green-500"></div>
            <div className="hidden hover:text-green-600"></div>
            <div className="hidden hover:text-green-700"></div>
            <div className="hidden hover:text-green-800"></div>
            <div className="hidden hover:text-green-900"></div>
            <div className="hidden hover:text-teal-50"></div>
            <div className="hidden hover:text-teal-100"></div>
            <div className="hidden hover:text-teal-200"></div>
            <div className="hidden hover:text-teal-300"></div>
            <div className="hidden hover:text-teal-400"></div>
            <div className="hidden hover:text-teal-500"></div>
            <div className="hidden hover:text-teal-600"></div>
            <div className="hidden hover:text-teal-700"></div>
            <div className="hidden hover:text-teal-800"></div>
            <div className="hidden hover:text-teal-900"></div>
            <div className="hidden hover:text-cyan-50"></div>
            <div className="hidden hover:text-cyan-100"></div>
            <div className="hidden hover:text-cyan-200"></div>
            <div className="hidden hover:text-cyan-300"></div>
            <div className="hidden hover:text-cyan-400"></div>
            <div className="hidden hover:text-cyan-500"></div>
            <div className="hidden hover:text-cyan-600"></div>
            <div className="hidden hover:text-cyan-700"></div>
            <div className="hidden hover:text-cyan-800"></div>
            <div className="hidden hover:text-cyan-900"></div>
            <div className="hidden hover:text-blue-50"></div>
            <div className="hidden hover:text-blue-100"></div>
            <div className="hidden hover:text-blue-200"></div>
            <div className="hidden hover:text-blue-300"></div>
            <div className="hidden hover:text-blue-400"></div>
            <div className="hidden hover:text-blue-500"></div>
            <div className="hidden hover:text-blue-600"></div>
            <div className="hidden hover:text-blue-700"></div>
            <div className="hidden hover:text-blue-800"></div>
            <div className="hidden hover:text-blue-900"></div>
            <div className="hidden hover:text-indigo-50"></div>
            <div className="hidden hover:text-indigo-100"></div>
            <div className="hidden hover:text-indigo-200"></div>
            <div className="hidden hover:text-indigo-300"></div>
            <div className="hidden hover:text-indigo-400"></div>
            <div className="hidden hover:text-indigo-500"></div>
            <div className="hidden hover:text-indigo-600"></div>
            <div className="hidden hover:text-indigo-700"></div>
            <div className="hidden hover:text-indigo-800"></div>
            <div className="hidden hover:text-indigo-900"></div>
            <div className="hidden hover:text-purple-50"></div>
            <div className="hidden hover:text-purple-100"></div>
            <div className="hidden hover:text-purple-200"></div>
            <div className="hidden hover:text-purple-300"></div>
            <div className="hidden hover:text-purple-400"></div>
            <div className="hidden hover:text-purple-500"></div>
            <div className="hidden hover:text-purple-600"></div>
            <div className="hidden hover:text-purple-700"></div>
            <div className="hidden hover:text-purple-800"></div>
            <div className="hidden hover:text-purple-900"></div>
            <div className="hidden hover:text-pink-50"></div>
            <div className="hidden hover:text-pink-100"></div>
            <div className="hidden hover:text-pink-200"></div>
            <div className="hidden hover:text-pink-300"></div>
            <div className="hidden hover:text-pink-400"></div>
            <div className="hidden hover:text-pink-500"></div>
            <div className="hidden hover:text-pink-600"></div>
            <div className="hidden hover:text-pink-700"></div>
            <div className="hidden hover:text-pink-800"></div>
            <div className="hidden hover:text-pink-900"></div>
            <div className="hidden hover:border-brand-50"></div>
            <div className="hidden hover:border-brand-100"></div>
            <div className="hidden hover:border-brand-200"></div>
            <div className="hidden hover:border-brand-300"></div>
            <div className="hidden hover:border-brand-400"></div>
            <div className="hidden hover:border-brand-500"></div>
            <div className="hidden hover:border-brand-600"></div>
            <div className="hidden hover:border-brand-700"></div>
            <div className="hidden hover:border-brand-800"></div>
            <div className="hidden hover:border-brand-900"></div>
            <div className="hidden hover:border-gray-50"></div>
            <div className="hidden hover:border-gray-100"></div>
            <div className="hidden hover:border-gray-200"></div>
            <div className="hidden hover:border-gray-300"></div>
            <div className="hidden hover:border-gray-400"></div>
            <div className="hidden hover:border-gray-500"></div>
            <div className="hidden hover:border-gray-600"></div>
            <div className="hidden hover:border-gray-700"></div>
            <div className="hidden hover:border-gray-800"></div>
            <div className="hidden hover:border-gray-900"></div>
            <div className="hidden hover:border-navy-50"></div>
            <div className="hidden hover:border-navy-100"></div>
            <div className="hidden hover:border-navy-200"></div>
            <div className="hidden hover:border-navy-300"></div>
            <div className="hidden hover:border-navy-400"></div>
            <div className="hidden hover:border-navy-500"></div>
            <div className="hidden hover:border-navy-600"></div>
            <div className="hidden hover:border-navy-700"></div>
            <div className="hidden hover:border-navy-800"></div>
            <div className="hidden hover:border-navy-900"></div>
            <div className="hidden hover:border-red-50"></div>
            <div className="hidden hover:border-red-100"></div>
            <div className="hidden hover:border-red-200"></div>
            <div className="hidden hover:border-red-300"></div>
            <div className="hidden hover:border-red-400"></div>
            <div className="hidden hover:border-red-500"></div>
            <div className="hidden hover:border-red-600"></div>
            <div className="hidden hover:border-red-700"></div>
            <div className="hidden hover:border-red-800"></div>
            <div className="hidden hover:border-red-900"></div>
            <div className="hidden hover:border-orange-50"></div>
            <div className="hidden hover:border-orange-100"></div>
            <div className="hidden hover:border-orange-200"></div>
            <div className="hidden hover:border-orange-300"></div>
            <div className="hidden hover:border-orange-400"></div>
            <div className="hidden hover:border-orange-500"></div>
            <div className="hidden hover:border-orange-600"></div>
            <div className="hidden hover:border-orange-700"></div>
            <div className="hidden hover:border-orange-800"></div>
            <div className="hidden hover:border-orange-900"></div>
            <div className="hidden hover:border-amber-50"></div>
            <div className="hidden hover:border-amber-100"></div>
            <div className="hidden hover:border-amber-200"></div>
            <div className="hidden hover:border-amber-300"></div>
            <div className="hidden hover:border-amber-400"></div>
            <div className="hidden hover:border-amber-500"></div>
            <div className="hidden hover:border-amber-600"></div>
            <div className="hidden hover:border-amber-700"></div>
            <div className="hidden hover:border-amber-800"></div>
            <div className="hidden hover:border-amber-900"></div>
            <div className="hidden hover:border-yellow-50"></div>
            <div className="hidden hover:border-yellow-100"></div>
            <div className="hidden hover:border-yellow-200"></div>
            <div className="hidden hover:border-yellow-300"></div>
            <div className="hidden hover:border-yellow-400"></div>
            <div className="hidden hover:border-yellow-500"></div>
            <div className="hidden hover:border-yellow-600"></div>
            <div className="hidden hover:border-yellow-700"></div>
            <div className="hidden hover:border-yellow-800"></div>
            <div className="hidden hover:border-yellow-900"></div>
            <div className="hidden hover:border-lime-50"></div>
            <div className="hidden hover:border-lime-100"></div>
            <div className="hidden hover:border-lime-200"></div>
            <div className="hidden hover:border-lime-300"></div>
            <div className="hidden hover:border-lime-400"></div>
            <div className="hidden hover:border-lime-500"></div>
            <div className="hidden hover:border-lime-600"></div>
            <div className="hidden hover:border-lime-700"></div>
            <div className="hidden hover:border-lime-800"></div>
            <div className="hidden hover:border-lime-900"></div>
            <div className="hidden hover:border-green-50"></div>
            <div className="hidden hover:border-green-100"></div>
            <div className="hidden hover:border-green-200"></div>
            <div className="hidden hover:border-green-300"></div>
            <div className="hidden hover:border-green-400"></div>
            <div className="hidden hover:border-green-500"></div>
            <div className="hidden hover:border-green-600"></div>
            <div className="hidden hover:border-green-700"></div>
            <div className="hidden hover:border-green-800"></div>
            <div className="hidden hover:border-green-900"></div>
            <div className="hidden hover:border-teal-50"></div>
            <div className="hidden hover:border-teal-100"></div>
            <div className="hidden hover:border-teal-200"></div>
            <div className="hidden hover:border-teal-300"></div>
            <div className="hidden hover:border-teal-400"></div>
            <div className="hidden hover:border-teal-500"></div>
            <div className="hidden hover:border-teal-600"></div>
            <div className="hidden hover:border-teal-700"></div>
            <div className="hidden hover:border-teal-800"></div>
            <div className="hidden hover:border-teal-900"></div>
            <div className="hidden hover:border-cyan-50"></div>
            <div className="hidden hover:border-cyan-100"></div>
            <div className="hidden hover:border-cyan-200"></div>
            <div className="hidden hover:border-cyan-300"></div>
            <div className="hidden hover:border-cyan-400"></div>
            <div className="hidden hover:border-cyan-500"></div>
            <div className="hidden hover:border-cyan-600"></div>
            <div className="hidden hover:border-cyan-700"></div>
            <div className="hidden hover:border-cyan-800"></div>
            <div className="hidden hover:border-cyan-900"></div>
            <div className="hidden hover:border-blue-50"></div>
            <div className="hidden hover:border-blue-100"></div>
            <div className="hidden hover:border-blue-200"></div>
            <div className="hidden hover:border-blue-300"></div>
            <div className="hidden hover:border-blue-400"></div>
            <div className="hidden hover:border-blue-500"></div>
            <div className="hidden hover:border-blue-600"></div>
            <div className="hidden hover:border-blue-700"></div>
            <div className="hidden hover:border-blue-800"></div>
            <div className="hidden hover:border-blue-900"></div>
            <div className="hidden hover:border-indigo-50"></div>
            <div className="hidden hover:border-indigo-100"></div>
            <div className="hidden hover:border-indigo-200"></div>
            <div className="hidden hover:border-indigo-300"></div>
            <div className="hidden hover:border-indigo-400"></div>
            <div className="hidden hover:border-indigo-500"></div>
            <div className="hidden hover:border-indigo-600"></div>
            <div className="hidden hover:border-indigo-700"></div>
            <div className="hidden hover:border-indigo-800"></div>
            <div className="hidden hover:border-indigo-900"></div>
            <div className="hidden hover:border-purple-50"></div>
            <div className="hidden hover:border-purple-100"></div>
            <div className="hidden hover:border-purple-200"></div>
            <div className="hidden hover:border-purple-300"></div>
            <div className="hidden hover:border-purple-400"></div>
            <div className="hidden hover:border-purple-500"></div>
            <div className="hidden hover:border-purple-600"></div>
            <div className="hidden hover:border-purple-700"></div>
            <div className="hidden hover:border-purple-800"></div>
            <div className="hidden hover:border-purple-900"></div>
            <div className="hidden hover:border-pink-50"></div>
            <div className="hidden hover:border-pink-100"></div>
            <div className="hidden hover:border-pink-200"></div>
            <div className="hidden hover:border-pink-300"></div>
            <div className="hidden hover:border-pink-400"></div>
            <div className="hidden hover:border-pink-500"></div>
            <div className="hidden hover:border-pink-600"></div>
            <div className="hidden hover:border-pink-700"></div>
            <div className="hidden hover:border-pink-800"></div>
            <div className="hidden hover:border-pink-900"></div>
            <div className="hidden hover:bg-brand-50"></div>
            <div className="hidden hover:bg-brand-100"></div>
            <div className="hidden hover:bg-brand-200"></div>
            <div className="hidden hover:bg-brand-300"></div>
            <div className="hidden hover:bg-brand-400"></div>
            <div className="hidden hover:bg-brand-500"></div>
            <div className="hidden hover:bg-brand-600"></div>
            <div className="hidden hover:bg-brand-700"></div>
            <div className="hidden hover:bg-brand-800"></div>
            <div className="hidden hover:bg-brand-900"></div>
            <div className="hidden hover:bg-gray-50"></div>
            <div className="hidden hover:bg-gray-100"></div>
            <div className="hidden hover:bg-gray-200"></div>
            <div className="hidden hover:bg-gray-300"></div>
            <div className="hidden hover:bg-gray-400"></div>
            <div className="hidden hover:bg-gray-500"></div>
            <div className="hidden hover:bg-gray-600"></div>
            <div className="hidden hover:bg-gray-700"></div>
            <div className="hidden hover:bg-gray-800"></div>
            <div className="hidden hover:bg-gray-900"></div>
            <div className="hidden hover:bg-navy-50"></div>
            <div className="hidden hover:bg-navy-100"></div>
            <div className="hidden hover:bg-navy-200"></div>
            <div className="hidden hover:bg-navy-300"></div>
            <div className="hidden hover:bg-navy-400"></div>
            <div className="hidden hover:bg-navy-500"></div>
            <div className="hidden hover:bg-navy-600"></div>
            <div className="hidden hover:bg-navy-700"></div>
            <div className="hidden hover:bg-navy-800"></div>
            <div className="hidden hover:bg-navy-900"></div>
            <div className="hidden hover:bg-red-50"></div>
            <div className="hidden hover:bg-red-100"></div>
            <div className="hidden hover:bg-red-200"></div>
            <div className="hidden hover:bg-red-300"></div>
            <div className="hidden hover:bg-red-400"></div>
            <div className="hidden hover:bg-red-500"></div>
            <div className="hidden hover:bg-red-600"></div>
            <div className="hidden hover:bg-red-700"></div>
            <div className="hidden hover:bg-red-800"></div>
            <div className="hidden hover:bg-red-900"></div>
            <div className="hidden hover:bg-orange-50"></div>
            <div className="hidden hover:bg-orange-100"></div>
            <div className="hidden hover:bg-orange-200"></div>
            <div className="hidden hover:bg-orange-300"></div>
            <div className="hidden hover:bg-orange-400"></div>
            <div className="hidden hover:bg-orange-500"></div>
            <div className="hidden hover:bg-orange-600"></div>
            <div className="hidden hover:bg-orange-700"></div>
            <div className="hidden hover:bg-orange-800"></div>
            <div className="hidden hover:bg-orange-900"></div>
            <div className="hidden hover:bg-amber-50"></div>
            <div className="hidden hover:bg-amber-100"></div>
            <div className="hidden hover:bg-amber-200"></div>
            <div className="hidden hover:bg-amber-300"></div>
            <div className="hidden hover:bg-amber-400"></div>
            <div className="hidden hover:bg-amber-500"></div>
            <div className="hidden hover:bg-amber-600"></div>
            <div className="hidden hover:bg-amber-700"></div>
            <div className="hidden hover:bg-amber-800"></div>
            <div className="hidden hover:bg-amber-900"></div>
            <div className="hidden hover:bg-yellow-50"></div>
            <div className="hidden hover:bg-yellow-100"></div>
            <div className="hidden hover:bg-yellow-200"></div>
            <div className="hidden hover:bg-yellow-300"></div>
            <div className="hidden hover:bg-yellow-400"></div>
            <div className="hidden hover:bg-yellow-500"></div>
            <div className="hidden hover:bg-yellow-600"></div>
            <div className="hidden hover:bg-yellow-700"></div>
            <div className="hidden hover:bg-yellow-800"></div>
            <div className="hidden hover:bg-yellow-900"></div>
            <div className="hidden hover:bg-lime-50"></div>
            <div className="hidden hover:bg-lime-100"></div>
            <div className="hidden hover:bg-lime-200"></div>
            <div className="hidden hover:bg-lime-300"></div>
            <div className="hidden hover:bg-lime-400"></div>
            <div className="hidden hover:bg-lime-500"></div>
            <div className="hidden hover:bg-lime-600"></div>
            <div className="hidden hover:bg-lime-700"></div>
            <div className="hidden hover:bg-lime-800"></div>
            <div className="hidden hover:bg-lime-900"></div>
            <div className="hidden hover:bg-green-50"></div>
            <div className="hidden hover:bg-green-100"></div>
            <div className="hidden hover:bg-green-200"></div>
            <div className="hidden hover:bg-green-300"></div>
            <div className="hidden hover:bg-green-400"></div>
            <div className="hidden hover:bg-green-500"></div>
            <div className="hidden hover:bg-green-600"></div>
            <div className="hidden hover:bg-green-700"></div>
            <div className="hidden hover:bg-green-800"></div>
            <div className="hidden hover:bg-green-900"></div>
            <div className="hidden hover:bg-teal-50"></div>
            <div className="hidden hover:bg-teal-100"></div>
            <div className="hidden hover:bg-teal-200"></div>
            <div className="hidden hover:bg-teal-300"></div>
            <div className="hidden hover:bg-teal-400"></div>
            <div className="hidden hover:bg-teal-500"></div>
            <div className="hidden hover:bg-teal-600"></div>
            <div className="hidden hover:bg-teal-700"></div>
            <div className="hidden hover:bg-teal-800"></div>
            <div className="hidden hover:bg-teal-900"></div>
            <div className="hidden hover:bg-cyan-50"></div>
            <div className="hidden hover:bg-cyan-100"></div>
            <div className="hidden hover:bg-cyan-200"></div>
            <div className="hidden hover:bg-cyan-300"></div>
            <div className="hidden hover:bg-cyan-400"></div>
            <div className="hidden hover:bg-cyan-500"></div>
            <div className="hidden hover:bg-cyan-600"></div>
            <div className="hidden hover:bg-cyan-700"></div>
            <div className="hidden hover:bg-cyan-800"></div>
            <div className="hidden hover:bg-cyan-900"></div>
            <div className="hidden hover:bg-blue-50"></div>
            <div className="hidden hover:bg-blue-100"></div>
            <div className="hidden hover:bg-blue-200"></div>
            <div className="hidden hover:bg-blue-300"></div>
            <div className="hidden hover:bg-blue-400"></div>
            <div className="hidden hover:bg-blue-500"></div>
            <div className="hidden hover:bg-blue-600"></div>
            <div className="hidden hover:bg-blue-700"></div>
            <div className="hidden hover:bg-blue-800"></div>
            <div className="hidden hover:bg-blue-900"></div>
            <div className="hidden hover:bg-indigo-50"></div>
            <div className="hidden hover:bg-indigo-100"></div>
            <div className="hidden hover:bg-indigo-200"></div>
            <div className="hidden hover:bg-indigo-300"></div>
            <div className="hidden hover:bg-indigo-400"></div>
            <div className="hidden hover:bg-indigo-500"></div>
            <div className="hidden hover:bg-indigo-600"></div>
            <div className="hidden hover:bg-indigo-700"></div>
            <div className="hidden hover:bg-indigo-800"></div>
            <div className="hidden hover:bg-indigo-900"></div>
            <div className="hidden hover:bg-purple-50"></div>
            <div className="hidden hover:bg-purple-100"></div>
            <div className="hidden hover:bg-purple-200"></div>
            <div className="hidden hover:bg-purple-300"></div>
            <div className="hidden hover:bg-purple-400"></div>
            <div className="hidden hover:bg-purple-500"></div>
            <div className="hidden hover:bg-purple-600"></div>
            <div className="hidden hover:bg-purple-700"></div>
            <div className="hidden hover:bg-purple-800"></div>
            <div className="hidden hover:bg-purple-900"></div>
            <div className="hidden hover:bg-pink-50"></div>
            <div className="hidden hover:bg-pink-100"></div>
            <div className="hidden hover:bg-pink-200"></div>
            <div className="hidden hover:bg-pink-300"></div>
            <div className="hidden hover:bg-pink-400"></div>
            <div className="hidden hover:bg-pink-500"></div>
            <div className="hidden hover:bg-pink-600"></div>
            <div className="hidden hover:bg-pink-700"></div>
            <div className="hidden hover:bg-pink-800"></div>
            <div className="hidden hover:bg-pink-900"></div>
            <div className="hidden dark:text-brand-50"></div>
            <div className="hidden dark:text-brand-100"></div>
            <div className="hidden dark:text-brand-200"></div>
            <div className="hidden dark:text-brand-300"></div>
            <div className="hidden dark:text-brand-400"></div>
            <div className="hidden dark:text-brand-500"></div>
            <div className="hidden dark:text-brand-600"></div>
            <div className="hidden dark:text-brand-700"></div>
            <div className="hidden dark:text-brand-800"></div>
            <div className="hidden dark:text-brand-900"></div>
            <div className="hidden dark:text-gray-50"></div>
            <div className="hidden dark:text-gray-100"></div>
            <div className="hidden dark:text-gray-200"></div>
            <div className="hidden dark:text-gray-300"></div>
            <div className="hidden dark:text-gray-400"></div>
            <div className="hidden dark:text-gray-500"></div>
            <div className="hidden dark:text-gray-600"></div>
            <div className="hidden dark:text-gray-700"></div>
            <div className="hidden dark:text-gray-800"></div>
            <div className="hidden dark:text-gray-900"></div>
            <div className="hidden dark:text-navy-50"></div>
            <div className="hidden dark:text-navy-100"></div>
            <div className="hidden dark:text-navy-200"></div>
            <div className="hidden dark:text-navy-300"></div>
            <div className="hidden dark:text-navy-400"></div>
            <div className="hidden dark:text-navy-500"></div>
            <div className="hidden dark:text-navy-600"></div>
            <div className="hidden dark:text-navy-700"></div>
            <div className="hidden dark:text-navy-800"></div>
            <div className="hidden dark:text-navy-900"></div>
            <div className="hidden dark:text-red-50"></div>
            <div className="hidden dark:text-red-100"></div>
            <div className="hidden dark:text-red-200"></div>
            <div className="hidden dark:text-red-300"></div>
            <div className="hidden dark:text-red-400"></div>
            <div className="hidden dark:text-red-500"></div>
            <div className="hidden dark:text-red-600"></div>
            <div className="hidden dark:text-red-700"></div>
            <div className="hidden dark:text-red-800"></div>
            <div className="hidden dark:text-red-900"></div>
            <div className="hidden dark:text-orange-50"></div>
            <div className="hidden dark:text-orange-100"></div>
            <div className="hidden dark:text-orange-200"></div>
            <div className="hidden dark:text-orange-300"></div>
            <div className="hidden dark:text-orange-400"></div>
            <div className="hidden dark:text-orange-500"></div>
            <div className="hidden dark:text-orange-600"></div>
            <div className="hidden dark:text-orange-700"></div>
            <div className="hidden dark:text-orange-800"></div>
            <div className="hidden dark:text-orange-900"></div>
            <div className="hidden dark:text-amber-50"></div>
            <div className="hidden dark:text-amber-100"></div>
            <div className="hidden dark:text-amber-200"></div>
            <div className="hidden dark:text-amber-300"></div>
            <div className="hidden dark:text-amber-400"></div>
            <div className="hidden dark:text-amber-500"></div>
            <div className="hidden dark:text-amber-600"></div>
            <div className="hidden dark:text-amber-700"></div>
            <div className="hidden dark:text-amber-800"></div>
            <div className="hidden dark:text-amber-900"></div>
            <div className="hidden dark:text-yellow-50"></div>
            <div className="hidden dark:text-yellow-100"></div>
            <div className="hidden dark:text-yellow-200"></div>
            <div className="hidden dark:text-yellow-300"></div>
            <div className="hidden dark:text-yellow-400"></div>
            <div className="hidden dark:text-yellow-500"></div>
            <div className="hidden dark:text-yellow-600"></div>
            <div className="hidden dark:text-yellow-700"></div>
            <div className="hidden dark:text-yellow-800"></div>
            <div className="hidden dark:text-yellow-900"></div>
            <div className="hidden dark:text-lime-50"></div>
            <div className="hidden dark:text-lime-100"></div>
            <div className="hidden dark:text-lime-200"></div>
            <div className="hidden dark:text-lime-300"></div>
            <div className="hidden dark:text-lime-400"></div>
            <div className="hidden dark:text-lime-500"></div>
            <div className="hidden dark:text-lime-600"></div>
            <div className="hidden dark:text-lime-700"></div>
            <div className="hidden dark:text-lime-800"></div>
            <div className="hidden dark:text-lime-900"></div>
            <div className="hidden dark:text-green-50"></div>
            <div className="hidden dark:text-green-100"></div>
            <div className="hidden dark:text-green-200"></div>
            <div className="hidden dark:text-green-300"></div>
            <div className="hidden dark:text-green-400"></div>
            <div className="hidden dark:text-green-500"></div>
            <div className="hidden dark:text-green-600"></div>
            <div className="hidden dark:text-green-700"></div>
            <div className="hidden dark:text-green-800"></div>
            <div className="hidden dark:text-green-900"></div>
            <div className="hidden dark:text-teal-50"></div>
            <div className="hidden dark:text-teal-100"></div>
            <div className="hidden dark:text-teal-200"></div>
            <div className="hidden dark:text-teal-300"></div>
            <div className="hidden dark:text-teal-400"></div>
            <div className="hidden dark:text-teal-500"></div>
            <div className="hidden dark:text-teal-600"></div>
            <div className="hidden dark:text-teal-700"></div>
            <div className="hidden dark:text-teal-800"></div>
            <div className="hidden dark:text-teal-900"></div>
            <div className="hidden dark:text-cyan-50"></div>
            <div className="hidden dark:text-cyan-100"></div>
            <div className="hidden dark:text-cyan-200"></div>
            <div className="hidden dark:text-cyan-300"></div>
            <div className="hidden dark:text-cyan-400"></div>
            <div className="hidden dark:text-cyan-500"></div>
            <div className="hidden dark:text-cyan-600"></div>
            <div className="hidden dark:text-cyan-700"></div>
            <div className="hidden dark:text-cyan-800"></div>
            <div className="hidden dark:text-cyan-900"></div>
            <div className="hidden dark:text-blue-50"></div>
            <div className="hidden dark:text-blue-100"></div>
            <div className="hidden dark:text-blue-200"></div>
            <div className="hidden dark:text-blue-300"></div>
            <div className="hidden dark:text-blue-400"></div>
            <div className="hidden dark:text-blue-500"></div>
            <div className="hidden dark:text-blue-600"></div>
            <div className="hidden dark:text-blue-700"></div>
            <div className="hidden dark:text-blue-800"></div>
            <div className="hidden dark:text-blue-900"></div>
            <div className="hidden dark:text-indigo-50"></div>
            <div className="hidden dark:text-indigo-100"></div>
            <div className="hidden dark:text-indigo-200"></div>
            <div className="hidden dark:text-indigo-300"></div>
            <div className="hidden dark:text-indigo-400"></div>
            <div className="hidden dark:text-indigo-500"></div>
            <div className="hidden dark:text-indigo-600"></div>
            <div className="hidden dark:text-indigo-700"></div>
            <div className="hidden dark:text-indigo-800"></div>
            <div className="hidden dark:text-indigo-900"></div>
            <div className="hidden dark:text-purple-50"></div>
            <div className="hidden dark:text-purple-100"></div>
            <div className="hidden dark:text-purple-200"></div>
            <div className="hidden dark:text-purple-300"></div>
            <div className="hidden dark:text-purple-400"></div>
            <div className="hidden dark:text-purple-500"></div>
            <div className="hidden dark:text-purple-600"></div>
            <div className="hidden dark:text-purple-700"></div>
            <div className="hidden dark:text-purple-800"></div>
            <div className="hidden dark:text-purple-900"></div>
            <div className="hidden dark:text-pink-50"></div>
            <div className="hidden dark:text-pink-100"></div>
            <div className="hidden dark:text-pink-200"></div>
            <div className="hidden dark:text-pink-300"></div>
            <div className="hidden dark:text-pink-400"></div>
            <div className="hidden dark:text-pink-500"></div>
            <div className="hidden dark:text-pink-600"></div>
            <div className="hidden dark:text-pink-700"></div>
            <div className="hidden dark:text-pink-800"></div>
            <div className="hidden dark:text-pink-900"></div>
            <div className="hidden dark:border-brand-50"></div>
            <div className="hidden dark:border-brand-100"></div>
            <div className="hidden dark:border-brand-200"></div>
            <div className="hidden dark:border-brand-300"></div>
            <div className="hidden dark:border-brand-400"></div>
            <div className="hidden dark:border-brand-500"></div>
            <div className="hidden dark:border-brand-600"></div>
            <div className="hidden dark:border-brand-700"></div>
            <div className="hidden dark:border-brand-800"></div>
            <div className="hidden dark:border-brand-900"></div>
            <div className="hidden dark:border-gray-50"></div>
            <div className="hidden dark:border-gray-100"></div>
            <div className="hidden dark:border-gray-200"></div>
            <div className="hidden dark:border-gray-300"></div>
            <div className="hidden dark:border-gray-400"></div>
            <div className="hidden dark:border-gray-500"></div>
            <div className="hidden dark:border-gray-600"></div>
            <div className="hidden dark:border-gray-700"></div>
            <div className="hidden dark:border-gray-800"></div>
            <div className="hidden dark:border-gray-900"></div>
            <div className="hidden dark:border-navy-50"></div>
            <div className="hidden dark:border-navy-100"></div>
            <div className="hidden dark:border-navy-200"></div>
            <div className="hidden dark:border-navy-300"></div>
            <div className="hidden dark:border-navy-400"></div>
            <div className="hidden dark:border-navy-500"></div>
            <div className="hidden dark:border-navy-600"></div>
            <div className="hidden dark:border-navy-700"></div>
            <div className="hidden dark:border-navy-800"></div>
            <div className="hidden dark:border-navy-900"></div>
            <div className="hidden dark:border-red-50"></div>
            <div className="hidden dark:border-red-100"></div>
            <div className="hidden dark:border-red-200"></div>
            <div className="hidden dark:border-red-300"></div>
            <div className="hidden dark:border-red-400"></div>
            <div className="hidden dark:border-red-500"></div>
            <div className="hidden dark:border-red-600"></div>
            <div className="hidden dark:border-red-700"></div>
            <div className="hidden dark:border-red-800"></div>
            <div className="hidden dark:border-red-900"></div>
            <div className="hidden dark:border-orange-50"></div>
            <div className="hidden dark:border-orange-100"></div>
            <div className="hidden dark:border-orange-200"></div>
            <div className="hidden dark:border-orange-300"></div>
            <div className="hidden dark:border-orange-400"></div>
            <div className="hidden dark:border-orange-500"></div>
            <div className="hidden dark:border-orange-600"></div>
            <div className="hidden dark:border-orange-700"></div>
            <div className="hidden dark:border-orange-800"></div>
            <div className="hidden dark:border-orange-900"></div>
            <div className="hidden dark:border-amber-50"></div>
            <div className="hidden dark:border-amber-100"></div>
            <div className="hidden dark:border-amber-200"></div>
            <div className="hidden dark:border-amber-300"></div>
            <div className="hidden dark:border-amber-400"></div>
            <div className="hidden dark:border-amber-500"></div>
            <div className="hidden dark:border-amber-600"></div>
            <div className="hidden dark:border-amber-700"></div>
            <div className="hidden dark:border-amber-800"></div>
            <div className="hidden dark:border-amber-900"></div>
            <div className="hidden dark:border-yellow-50"></div>
            <div className="hidden dark:border-yellow-100"></div>
            <div className="hidden dark:border-yellow-200"></div>
            <div className="hidden dark:border-yellow-300"></div>
            <div className="hidden dark:border-yellow-400"></div>
            <div className="hidden dark:border-yellow-500"></div>
            <div className="hidden dark:border-yellow-600"></div>
            <div className="hidden dark:border-yellow-700"></div>
            <div className="hidden dark:border-yellow-800"></div>
            <div className="hidden dark:border-yellow-900"></div>
            <div className="hidden dark:border-lime-50"></div>
            <div className="hidden dark:border-lime-100"></div>
            <div className="hidden dark:border-lime-200"></div>
            <div className="hidden dark:border-lime-300"></div>
            <div className="hidden dark:border-lime-400"></div>
            <div className="hidden dark:border-lime-500"></div>
            <div className="hidden dark:border-lime-600"></div>
            <div className="hidden dark:border-lime-700"></div>
            <div className="hidden dark:border-lime-800"></div>
            <div className="hidden dark:border-lime-900"></div>
            <div className="hidden dark:border-green-50"></div>
            <div className="hidden dark:border-green-100"></div>
            <div className="hidden dark:border-green-200"></div>
            <div className="hidden dark:border-green-300"></div>
            <div className="hidden dark:border-green-400"></div>
            <div className="hidden dark:border-green-500"></div>
            <div className="hidden dark:border-green-600"></div>
            <div className="hidden dark:border-green-700"></div>
            <div className="hidden dark:border-green-800"></div>
            <div className="hidden dark:border-green-900"></div>
            <div className="hidden dark:border-teal-50"></div>
            <div className="hidden dark:border-teal-100"></div>
            <div className="hidden dark:border-teal-200"></div>
            <div className="hidden dark:border-teal-300"></div>
            <div className="hidden dark:border-teal-400"></div>
            <div className="hidden dark:border-teal-500"></div>
            <div className="hidden dark:border-teal-600"></div>
            <div className="hidden dark:border-teal-700"></div>
            <div className="hidden dark:border-teal-800"></div>
            <div className="hidden dark:border-teal-900"></div>
            <div className="hidden dark:border-cyan-50"></div>
            <div className="hidden dark:border-cyan-100"></div>
            <div className="hidden dark:border-cyan-200"></div>
            <div className="hidden dark:border-cyan-300"></div>
            <div className="hidden dark:border-cyan-400"></div>
            <div className="hidden dark:border-cyan-500"></div>
            <div className="hidden dark:border-cyan-600"></div>
            <div className="hidden dark:border-cyan-700"></div>
            <div className="hidden dark:border-cyan-800"></div>
            <div className="hidden dark:border-cyan-900"></div>
            <div className="hidden dark:border-blue-50"></div>
            <div className="hidden dark:border-blue-100"></div>
            <div className="hidden dark:border-blue-200"></div>
            <div className="hidden dark:border-blue-300"></div>
            <div className="hidden dark:border-blue-400"></div>
            <div className="hidden dark:border-blue-500"></div>
            <div className="hidden dark:border-blue-600"></div>
            <div className="hidden dark:border-blue-700"></div>
            <div className="hidden dark:border-blue-800"></div>
            <div className="hidden dark:border-blue-900"></div>
            <div className="hidden dark:border-indigo-50"></div>
            <div className="hidden dark:border-indigo-100"></div>
            <div className="hidden dark:border-indigo-200"></div>
            <div className="hidden dark:border-indigo-300"></div>
            <div className="hidden dark:border-indigo-400"></div>
            <div className="hidden dark:border-indigo-500"></div>
            <div className="hidden dark:border-indigo-600"></div>
            <div className="hidden dark:border-indigo-700"></div>
            <div className="hidden dark:border-indigo-800"></div>
            <div className="hidden dark:border-indigo-900"></div>
            <div className="hidden dark:border-purple-50"></div>
            <div className="hidden dark:border-purple-100"></div>
            <div className="hidden dark:border-purple-200"></div>
            <div className="hidden dark:border-purple-300"></div>
            <div className="hidden dark:border-purple-400"></div>
            <div className="hidden dark:border-purple-500"></div>
            <div className="hidden dark:border-purple-600"></div>
            <div className="hidden dark:border-purple-700"></div>
            <div className="hidden dark:border-purple-800"></div>
            <div className="hidden dark:border-purple-900"></div>
            <div className="hidden dark:border-pink-50"></div>
            <div className="hidden dark:border-pink-100"></div>
            <div className="hidden dark:border-pink-200"></div>
            <div className="hidden dark:border-pink-300"></div>
            <div className="hidden dark:border-pink-400"></div>
            <div className="hidden dark:border-pink-500"></div>
            <div className="hidden dark:border-pink-600"></div>
            <div className="hidden dark:border-pink-700"></div>
            <div className="hidden dark:border-pink-800"></div>
            <div className="hidden dark:border-pink-900"></div>
            <div className="hidden dark:bg-brand-50"></div>
            <div className="hidden dark:bg-brand-100"></div>
            <div className="hidden dark:bg-brand-200"></div>
            <div className="hidden dark:bg-brand-300"></div>
            <div className="hidden dark:bg-brand-400"></div>
            <div className="hidden dark:bg-brand-500"></div>
            <div className="hidden dark:bg-brand-600"></div>
            <div className="hidden dark:bg-brand-700"></div>
            <div className="hidden dark:bg-brand-800"></div>
            <div className="hidden dark:bg-brand-900"></div>
            <div className="hidden dark:bg-gray-50"></div>
            <div className="hidden dark:bg-gray-100"></div>
            <div className="hidden dark:bg-gray-200"></div>
            <div className="hidden dark:bg-gray-300"></div>
            <div className="hidden dark:bg-gray-400"></div>
            <div className="hidden dark:bg-gray-500"></div>
            <div className="hidden dark:bg-gray-600"></div>
            <div className="hidden dark:bg-gray-700"></div>
            <div className="hidden dark:bg-gray-800"></div>
            <div className="hidden dark:bg-gray-900"></div>
            <div className="hidden dark:bg-navy-50"></div>
            <div className="hidden dark:bg-navy-100"></div>
            <div className="hidden dark:bg-navy-200"></div>
            <div className="hidden dark:bg-navy-300"></div>
            <div className="hidden dark:bg-navy-400"></div>
            <div className="hidden dark:bg-navy-500"></div>
            <div className="hidden dark:bg-navy-600"></div>
            <div className="hidden dark:bg-navy-700"></div>
            <div className="hidden dark:bg-navy-800"></div>
            <div className="hidden dark:bg-navy-900"></div>
            <div className="hidden dark:bg-red-50"></div>
            <div className="hidden dark:bg-red-100"></div>
            <div className="hidden dark:bg-red-200"></div>
            <div className="hidden dark:bg-red-300"></div>
            <div className="hidden dark:bg-red-400"></div>
            <div className="hidden dark:bg-red-500"></div>
            <div className="hidden dark:bg-red-600"></div>
            <div className="hidden dark:bg-red-700"></div>
            <div className="hidden dark:bg-red-800"></div>
            <div className="hidden dark:bg-red-900"></div>
            <div className="hidden dark:bg-orange-50"></div>
            <div className="hidden dark:bg-orange-100"></div>
            <div className="hidden dark:bg-orange-200"></div>
            <div className="hidden dark:bg-orange-300"></div>
            <div className="hidden dark:bg-orange-400"></div>
            <div className="hidden dark:bg-orange-500"></div>
            <div className="hidden dark:bg-orange-600"></div>
            <div className="hidden dark:bg-orange-700"></div>
            <div className="hidden dark:bg-orange-800"></div>
            <div className="hidden dark:bg-orange-900"></div>
            <div className="hidden dark:bg-amber-50"></div>
            <div className="hidden dark:bg-amber-100"></div>
            <div className="hidden dark:bg-amber-200"></div>
            <div className="hidden dark:bg-amber-300"></div>
            <div className="hidden dark:bg-amber-400"></div>
            <div className="hidden dark:bg-amber-500"></div>
            <div className="hidden dark:bg-amber-600"></div>
            <div className="hidden dark:bg-amber-700"></div>
            <div className="hidden dark:bg-amber-800"></div>
            <div className="hidden dark:bg-amber-900"></div>
            <div className="hidden dark:bg-yellow-50"></div>
            <div className="hidden dark:bg-yellow-100"></div>
            <div className="hidden dark:bg-yellow-200"></div>
            <div className="hidden dark:bg-yellow-300"></div>
            <div className="hidden dark:bg-yellow-400"></div>
            <div className="hidden dark:bg-yellow-500"></div>
            <div className="hidden dark:bg-yellow-600"></div>
            <div className="hidden dark:bg-yellow-700"></div>
            <div className="hidden dark:bg-yellow-800"></div>
            <div className="hidden dark:bg-yellow-900"></div>
            <div className="hidden dark:bg-lime-50"></div>
            <div className="hidden dark:bg-lime-100"></div>
            <div className="hidden dark:bg-lime-200"></div>
            <div className="hidden dark:bg-lime-300"></div>
            <div className="hidden dark:bg-lime-400"></div>
            <div className="hidden dark:bg-lime-500"></div>
            <div className="hidden dark:bg-lime-600"></div>
            <div className="hidden dark:bg-lime-700"></div>
            <div className="hidden dark:bg-lime-800"></div>
            <div className="hidden dark:bg-lime-900"></div>
            <div className="hidden dark:bg-green-50"></div>
            <div className="hidden dark:bg-green-100"></div>
            <div className="hidden dark:bg-green-200"></div>
            <div className="hidden dark:bg-green-300"></div>
            <div className="hidden dark:bg-green-400"></div>
            <div className="hidden dark:bg-green-500"></div>
            <div className="hidden dark:bg-green-600"></div>
            <div className="hidden dark:bg-green-700"></div>
            <div className="hidden dark:bg-green-800"></div>
            <div className="hidden dark:bg-green-900"></div>
            <div className="hidden dark:bg-teal-50"></div>
            <div className="hidden dark:bg-teal-100"></div>
            <div className="hidden dark:bg-teal-200"></div>
            <div className="hidden dark:bg-teal-300"></div>
            <div className="hidden dark:bg-teal-400"></div>
            <div className="hidden dark:bg-teal-500"></div>
            <div className="hidden dark:bg-teal-600"></div>
            <div className="hidden dark:bg-teal-700"></div>
            <div className="hidden dark:bg-teal-800"></div>
            <div className="hidden dark:bg-teal-900"></div>
            <div className="hidden dark:bg-cyan-50"></div>
            <div className="hidden dark:bg-cyan-100"></div>
            <div className="hidden dark:bg-cyan-200"></div>
            <div className="hidden dark:bg-cyan-300"></div>
            <div className="hidden dark:bg-cyan-400"></div>
            <div className="hidden dark:bg-cyan-500"></div>
            <div className="hidden dark:bg-cyan-600"></div>
            <div className="hidden dark:bg-cyan-700"></div>
            <div className="hidden dark:bg-cyan-800"></div>
            <div className="hidden dark:bg-cyan-900"></div>
            <div className="hidden dark:bg-blue-50"></div>
            <div className="hidden dark:bg-blue-100"></div>
            <div className="hidden dark:bg-blue-200"></div>
            <div className="hidden dark:bg-blue-300"></div>
            <div className="hidden dark:bg-blue-400"></div>
            <div className="hidden dark:bg-blue-500"></div>
            <div className="hidden dark:bg-blue-600"></div>
            <div className="hidden dark:bg-blue-700"></div>
            <div className="hidden dark:bg-blue-800"></div>
            <div className="hidden dark:bg-blue-900"></div>
            <div className="hidden dark:bg-indigo-50"></div>
            <div className="hidden dark:bg-indigo-100"></div>
            <div className="hidden dark:bg-indigo-200"></div>
            <div className="hidden dark:bg-indigo-300"></div>
            <div className="hidden dark:bg-indigo-400"></div>
            <div className="hidden dark:bg-indigo-500"></div>
            <div className="hidden dark:bg-indigo-600"></div>
            <div className="hidden dark:bg-indigo-700"></div>
            <div className="hidden dark:bg-indigo-800"></div>
            <div className="hidden dark:bg-indigo-900"></div>
            <div className="hidden dark:bg-purple-50"></div>
            <div className="hidden dark:bg-purple-100"></div>
            <div className="hidden dark:bg-purple-200"></div>
            <div className="hidden dark:bg-purple-300"></div>
            <div className="hidden dark:bg-purple-400"></div>
            <div className="hidden dark:bg-purple-500"></div>
            <div className="hidden dark:bg-purple-600"></div>
            <div className="hidden dark:bg-purple-700"></div>
            <div className="hidden dark:bg-purple-800"></div>
            <div className="hidden dark:bg-purple-900"></div>
            <div className="hidden dark:bg-pink-50"></div>
            <div className="hidden dark:bg-pink-100"></div>
            <div className="hidden dark:bg-pink-200"></div>
            <div className="hidden dark:bg-pink-300"></div>
            <div className="hidden dark:bg-pink-400"></div>
            <div className="hidden dark:bg-pink-500"></div>
            <div className="hidden dark:bg-pink-600"></div>
            <div className="hidden dark:bg-pink-700"></div>
            <div className="hidden dark:bg-pink-800"></div>
            <div className="hidden dark:bg-pink-900"></div>
            <div className="hidden dark:hover:text-brand-50"></div>
            <div className="hidden dark:hover:text-brand-100"></div>
            <div className="hidden dark:hover:text-brand-200"></div>
            <div className="hidden dark:hover:text-brand-300"></div>
            <div className="hidden dark:hover:text-brand-400"></div>
            <div className="hidden dark:hover:text-brand-500"></div>
            <div className="hidden dark:hover:text-brand-600"></div>
            <div className="hidden dark:hover:text-brand-700"></div>
            <div className="hidden dark:hover:text-brand-800"></div>
            <div className="hidden dark:hover:text-brand-900"></div>
            <div className="hidden dark:hover:text-gray-50"></div>
            <div className="hidden dark:hover:text-gray-100"></div>
            <div className="hidden dark:hover:text-gray-200"></div>
            <div className="hidden dark:hover:text-gray-300"></div>
            <div className="hidden dark:hover:text-gray-400"></div>
            <div className="hidden dark:hover:text-gray-500"></div>
            <div className="hidden dark:hover:text-gray-600"></div>
            <div className="hidden dark:hover:text-gray-700"></div>
            <div className="hidden dark:hover:text-gray-800"></div>
            <div className="hidden dark:hover:text-gray-900"></div>
            <div className="hidden dark:hover:text-navy-50"></div>
            <div className="hidden dark:hover:text-navy-100"></div>
            <div className="hidden dark:hover:text-navy-200"></div>
            <div className="hidden dark:hover:text-navy-300"></div>
            <div className="hidden dark:hover:text-navy-400"></div>
            <div className="hidden dark:hover:text-navy-500"></div>
            <div className="hidden dark:hover:text-navy-600"></div>
            <div className="hidden dark:hover:text-navy-700"></div>
            <div className="hidden dark:hover:text-navy-800"></div>
            <div className="hidden dark:hover:text-navy-900"></div>
            <div className="hidden dark:hover:text-red-50"></div>
            <div className="hidden dark:hover:text-red-100"></div>
            <div className="hidden dark:hover:text-red-200"></div>
            <div className="hidden dark:hover:text-red-300"></div>
            <div className="hidden dark:hover:text-red-400"></div>
            <div className="hidden dark:hover:text-red-500"></div>
            <div className="hidden dark:hover:text-red-600"></div>
            <div className="hidden dark:hover:text-red-700"></div>
            <div className="hidden dark:hover:text-red-800"></div>
            <div className="hidden dark:hover:text-red-900"></div>
            <div className="hidden dark:hover:text-orange-50"></div>
            <div className="hidden dark:hover:text-orange-100"></div>
            <div className="hidden dark:hover:text-orange-200"></div>
            <div className="hidden dark:hover:text-orange-300"></div>
            <div className="hidden dark:hover:text-orange-400"></div>
            <div className="hidden dark:hover:text-orange-500"></div>
            <div className="hidden dark:hover:text-orange-600"></div>
            <div className="hidden dark:hover:text-orange-700"></div>
            <div className="hidden dark:hover:text-orange-800"></div>
            <div className="hidden dark:hover:text-orange-900"></div>
            <div className="hidden dark:hover:text-amber-50"></div>
            <div className="hidden dark:hover:text-amber-100"></div>
            <div className="hidden dark:hover:text-amber-200"></div>
            <div className="hidden dark:hover:text-amber-300"></div>
            <div className="hidden dark:hover:text-amber-400"></div>
            <div className="hidden dark:hover:text-amber-500"></div>
            <div className="hidden dark:hover:text-amber-600"></div>
            <div className="hidden dark:hover:text-amber-700"></div>
            <div className="hidden dark:hover:text-amber-800"></div>
            <div className="hidden dark:hover:text-amber-900"></div>
            <div className="hidden dark:hover:text-yellow-50"></div>
            <div className="hidden dark:hover:text-yellow-100"></div>
            <div className="hidden dark:hover:text-yellow-200"></div>
            <div className="hidden dark:hover:text-yellow-300"></div>
            <div className="hidden dark:hover:text-yellow-400"></div>
            <div className="hidden dark:hover:text-yellow-500"></div>
            <div className="hidden dark:hover:text-yellow-600"></div>
            <div className="hidden dark:hover:text-yellow-700"></div>
            <div className="hidden dark:hover:text-yellow-800"></div>
            <div className="hidden dark:hover:text-yellow-900"></div>
            <div className="hidden dark:hover:text-lime-50"></div>
            <div className="hidden dark:hover:text-lime-100"></div>
            <div className="hidden dark:hover:text-lime-200"></div>
            <div className="hidden dark:hover:text-lime-300"></div>
            <div className="hidden dark:hover:text-lime-400"></div>
            <div className="hidden dark:hover:text-lime-500"></div>
            <div className="hidden dark:hover:text-lime-600"></div>
            <div className="hidden dark:hover:text-lime-700"></div>
            <div className="hidden dark:hover:text-lime-800"></div>
            <div className="hidden dark:hover:text-lime-900"></div>
            <div className="hidden dark:hover:text-green-50"></div>
            <div className="hidden dark:hover:text-green-100"></div>
            <div className="hidden dark:hover:text-green-200"></div>
            <div className="hidden dark:hover:text-green-300"></div>
            <div className="hidden dark:hover:text-green-400"></div>
            <div className="hidden dark:hover:text-green-500"></div>
            <div className="hidden dark:hover:text-green-600"></div>
            <div className="hidden dark:hover:text-green-700"></div>
            <div className="hidden dark:hover:text-green-800"></div>
            <div className="hidden dark:hover:text-green-900"></div>
            <div className="hidden dark:hover:text-teal-50"></div>
            <div className="hidden dark:hover:text-teal-100"></div>
            <div className="hidden dark:hover:text-teal-200"></div>
            <div className="hidden dark:hover:text-teal-300"></div>
            <div className="hidden dark:hover:text-teal-400"></div>
            <div className="hidden dark:hover:text-teal-500"></div>
            <div className="hidden dark:hover:text-teal-600"></div>
            <div className="hidden dark:hover:text-teal-700"></div>
            <div className="hidden dark:hover:text-teal-800"></div>
            <div className="hidden dark:hover:text-teal-900"></div>
            <div className="hidden dark:hover:text-cyan-50"></div>
            <div className="hidden dark:hover:text-cyan-100"></div>
            <div className="hidden dark:hover:text-cyan-200"></div>
            <div className="hidden dark:hover:text-cyan-300"></div>
            <div className="hidden dark:hover:text-cyan-400"></div>
            <div className="hidden dark:hover:text-cyan-500"></div>
            <div className="hidden dark:hover:text-cyan-600"></div>
            <div className="hidden dark:hover:text-cyan-700"></div>
            <div className="hidden dark:hover:text-cyan-800"></div>
            <div className="hidden dark:hover:text-cyan-900"></div>
            <div className="hidden dark:hover:text-blue-50"></div>
            <div className="hidden dark:hover:text-blue-100"></div>
            <div className="hidden dark:hover:text-blue-200"></div>
            <div className="hidden dark:hover:text-blue-300"></div>
            <div className="hidden dark:hover:text-blue-400"></div>
            <div className="hidden dark:hover:text-blue-500"></div>
            <div className="hidden dark:hover:text-blue-600"></div>
            <div className="hidden dark:hover:text-blue-700"></div>
            <div className="hidden dark:hover:text-blue-800"></div>
            <div className="hidden dark:hover:text-blue-900"></div>
            <div className="hidden dark:hover:text-indigo-50"></div>
            <div className="hidden dark:hover:text-indigo-100"></div>
            <div className="hidden dark:hover:text-indigo-200"></div>
            <div className="hidden dark:hover:text-indigo-300"></div>
            <div className="hidden dark:hover:text-indigo-400"></div>
            <div className="hidden dark:hover:text-indigo-500"></div>
            <div className="hidden dark:hover:text-indigo-600"></div>
            <div className="hidden dark:hover:text-indigo-700"></div>
            <div className="hidden dark:hover:text-indigo-800"></div>
            <div className="hidden dark:hover:text-indigo-900"></div>
            <div className="hidden dark:hover:text-purple-50"></div>
            <div className="hidden dark:hover:text-purple-100"></div>
            <div className="hidden dark:hover:text-purple-200"></div>
            <div className="hidden dark:hover:text-purple-300"></div>
            <div className="hidden dark:hover:text-purple-400"></div>
            <div className="hidden dark:hover:text-purple-500"></div>
            <div className="hidden dark:hover:text-purple-600"></div>
            <div className="hidden dark:hover:text-purple-700"></div>
            <div className="hidden dark:hover:text-purple-800"></div>
            <div className="hidden dark:hover:text-purple-900"></div>
            <div className="hidden dark:hover:text-pink-50"></div>
            <div className="hidden dark:hover:text-pink-100"></div>
            <div className="hidden dark:hover:text-pink-200"></div>
            <div className="hidden dark:hover:text-pink-300"></div>
            <div className="hidden dark:hover:text-pink-400"></div>
            <div className="hidden dark:hover:text-pink-500"></div>
            <div className="hidden dark:hover:text-pink-600"></div>
            <div className="hidden dark:hover:text-pink-700"></div>
            <div className="hidden dark:hover:text-pink-800"></div>
            <div className="hidden dark:hover:text-pink-900"></div>
            <div className="hidden dark:hover:border-brand-50"></div>
            <div className="hidden dark:hover:border-brand-100"></div>
            <div className="hidden dark:hover:border-brand-200"></div>
            <div className="hidden dark:hover:border-brand-300"></div>
            <div className="hidden dark:hover:border-brand-400"></div>
            <div className="hidden dark:hover:border-brand-500"></div>
            <div className="hidden dark:hover:border-brand-600"></div>
            <div className="hidden dark:hover:border-brand-700"></div>
            <div className="hidden dark:hover:border-brand-800"></div>
            <div className="hidden dark:hover:border-brand-900"></div>
            <div className="hidden dark:hover:border-gray-50"></div>
            <div className="hidden dark:hover:border-gray-100"></div>
            <div className="hidden dark:hover:border-gray-200"></div>
            <div className="hidden dark:hover:border-gray-300"></div>
            <div className="hidden dark:hover:border-gray-400"></div>
            <div className="hidden dark:hover:border-gray-500"></div>
            <div className="hidden dark:hover:border-gray-600"></div>
            <div className="hidden dark:hover:border-gray-700"></div>
            <div className="hidden dark:hover:border-gray-800"></div>
            <div className="hidden dark:hover:border-gray-900"></div>
            <div className="hidden dark:hover:border-navy-50"></div>
            <div className="hidden dark:hover:border-navy-100"></div>
            <div className="hidden dark:hover:border-navy-200"></div>
            <div className="hidden dark:hover:border-navy-300"></div>
            <div className="hidden dark:hover:border-navy-400"></div>
            <div className="hidden dark:hover:border-navy-500"></div>
            <div className="hidden dark:hover:border-navy-600"></div>
            <div className="hidden dark:hover:border-navy-700"></div>
            <div className="hidden dark:hover:border-navy-800"></div>
            <div className="hidden dark:hover:border-navy-900"></div>
            <div className="hidden dark:hover:border-red-50"></div>
            <div className="hidden dark:hover:border-red-100"></div>
            <div className="hidden dark:hover:border-red-200"></div>
            <div className="hidden dark:hover:border-red-300"></div>
            <div className="hidden dark:hover:border-red-400"></div>
            <div className="hidden dark:hover:border-red-500"></div>
            <div className="hidden dark:hover:border-red-600"></div>
            <div className="hidden dark:hover:border-red-700"></div>
            <div className="hidden dark:hover:border-red-800"></div>
            <div className="hidden dark:hover:border-red-900"></div>
            <div className="hidden dark:hover:border-orange-50"></div>
            <div className="hidden dark:hover:border-orange-100"></div>
            <div className="hidden dark:hover:border-orange-200"></div>
            <div className="hidden dark:hover:border-orange-300"></div>
            <div className="hidden dark:hover:border-orange-400"></div>
            <div className="hidden dark:hover:border-orange-500"></div>
            <div className="hidden dark:hover:border-orange-600"></div>
            <div className="hidden dark:hover:border-orange-700"></div>
            <div className="hidden dark:hover:border-orange-800"></div>
            <div className="hidden dark:hover:border-orange-900"></div>
            <div className="hidden dark:hover:border-amber-50"></div>
            <div className="hidden dark:hover:border-amber-100"></div>
            <div className="hidden dark:hover:border-amber-200"></div>
            <div className="hidden dark:hover:border-amber-300"></div>
            <div className="hidden dark:hover:border-amber-400"></div>
            <div className="hidden dark:hover:border-amber-500"></div>
            <div className="hidden dark:hover:border-amber-600"></div>
            <div className="hidden dark:hover:border-amber-700"></div>
            <div className="hidden dark:hover:border-amber-800"></div>
            <div className="hidden dark:hover:border-amber-900"></div>
            <div className="hidden dark:hover:border-yellow-50"></div>
            <div className="hidden dark:hover:border-yellow-100"></div>
            <div className="hidden dark:hover:border-yellow-200"></div>
            <div className="hidden dark:hover:border-yellow-300"></div>
            <div className="hidden dark:hover:border-yellow-400"></div>
            <div className="hidden dark:hover:border-yellow-500"></div>
            <div className="hidden dark:hover:border-yellow-600"></div>
            <div className="hidden dark:hover:border-yellow-700"></div>
            <div className="hidden dark:hover:border-yellow-800"></div>
            <div className="hidden dark:hover:border-yellow-900"></div>
            <div className="hidden dark:hover:border-lime-50"></div>
            <div className="hidden dark:hover:border-lime-100"></div>
            <div className="hidden dark:hover:border-lime-200"></div>
            <div className="hidden dark:hover:border-lime-300"></div>
            <div className="hidden dark:hover:border-lime-400"></div>
            <div className="hidden dark:hover:border-lime-500"></div>
            <div className="hidden dark:hover:border-lime-600"></div>
            <div className="hidden dark:hover:border-lime-700"></div>
            <div className="hidden dark:hover:border-lime-800"></div>
            <div className="hidden dark:hover:border-lime-900"></div>
            <div className="hidden dark:hover:border-green-50"></div>
            <div className="hidden dark:hover:border-green-100"></div>
            <div className="hidden dark:hover:border-green-200"></div>
            <div className="hidden dark:hover:border-green-300"></div>
            <div className="hidden dark:hover:border-green-400"></div>
            <div className="hidden dark:hover:border-green-500"></div>
            <div className="hidden dark:hover:border-green-600"></div>
            <div className="hidden dark:hover:border-green-700"></div>
            <div className="hidden dark:hover:border-green-800"></div>
            <div className="hidden dark:hover:border-green-900"></div>
            <div className="hidden dark:hover:border-teal-50"></div>
            <div className="hidden dark:hover:border-teal-100"></div>
            <div className="hidden dark:hover:border-teal-200"></div>
            <div className="hidden dark:hover:border-teal-300"></div>
            <div className="hidden dark:hover:border-teal-400"></div>
            <div className="hidden dark:hover:border-teal-500"></div>
            <div className="hidden dark:hover:border-teal-600"></div>
            <div className="hidden dark:hover:border-teal-700"></div>
            <div className="hidden dark:hover:border-teal-800"></div>
            <div className="hidden dark:hover:border-teal-900"></div>
            <div className="hidden dark:hover:border-cyan-50"></div>
            <div className="hidden dark:hover:border-cyan-100"></div>
            <div className="hidden dark:hover:border-cyan-200"></div>
            <div className="hidden dark:hover:border-cyan-300"></div>
            <div className="hidden dark:hover:border-cyan-400"></div>
            <div className="hidden dark:hover:border-cyan-500"></div>
            <div className="hidden dark:hover:border-cyan-600"></div>
            <div className="hidden dark:hover:border-cyan-700"></div>
            <div className="hidden dark:hover:border-cyan-800"></div>
            <div className="hidden dark:hover:border-cyan-900"></div>
            <div className="hidden dark:hover:border-blue-50"></div>
            <div className="hidden dark:hover:border-blue-100"></div>
            <div className="hidden dark:hover:border-blue-200"></div>
            <div className="hidden dark:hover:border-blue-300"></div>
            <div className="hidden dark:hover:border-blue-400"></div>
            <div className="hidden dark:hover:border-blue-500"></div>
            <div className="hidden dark:hover:border-blue-600"></div>
            <div className="hidden dark:hover:border-blue-700"></div>
            <div className="hidden dark:hover:border-blue-800"></div>
            <div className="hidden dark:hover:border-blue-900"></div>
            <div className="hidden dark:hover:border-indigo-50"></div>
            <div className="hidden dark:hover:border-indigo-100"></div>
            <div className="hidden dark:hover:border-indigo-200"></div>
            <div className="hidden dark:hover:border-indigo-300"></div>
            <div className="hidden dark:hover:border-indigo-400"></div>
            <div className="hidden dark:hover:border-indigo-500"></div>
            <div className="hidden dark:hover:border-indigo-600"></div>
            <div className="hidden dark:hover:border-indigo-700"></div>
            <div className="hidden dark:hover:border-indigo-800"></div>
            <div className="hidden dark:hover:border-indigo-900"></div>
            <div className="hidden dark:hover:border-purple-50"></div>
            <div className="hidden dark:hover:border-purple-100"></div>
            <div className="hidden dark:hover:border-purple-200"></div>
            <div className="hidden dark:hover:border-purple-300"></div>
            <div className="hidden dark:hover:border-purple-400"></div>
            <div className="hidden dark:hover:border-purple-500"></div>
            <div className="hidden dark:hover:border-purple-600"></div>
            <div className="hidden dark:hover:border-purple-700"></div>
            <div className="hidden dark:hover:border-purple-800"></div>
            <div className="hidden dark:hover:border-purple-900"></div>
            <div className="hidden dark:hover:border-pink-50"></div>
            <div className="hidden dark:hover:border-pink-100"></div>
            <div className="hidden dark:hover:border-pink-200"></div>
            <div className="hidden dark:hover:border-pink-300"></div>
            <div className="hidden dark:hover:border-pink-400"></div>
            <div className="hidden dark:hover:border-pink-500"></div>
            <div className="hidden dark:hover:border-pink-600"></div>
            <div className="hidden dark:hover:border-pink-700"></div>
            <div className="hidden dark:hover:border-pink-800"></div>
            <div className="hidden dark:hover:border-pink-900"></div>
            <div className="hidden dark:hover:bg-brand-50"></div>
            <div className="hidden dark:hover:bg-brand-100"></div>
            <div className="hidden dark:hover:bg-brand-200"></div>
            <div className="hidden dark:hover:bg-brand-300"></div>
            <div className="hidden dark:hover:bg-brand-400"></div>
            <div className="hidden dark:hover:bg-brand-500"></div>
            <div className="hidden dark:hover:bg-brand-600"></div>
            <div className="hidden dark:hover:bg-brand-700"></div>
            <div className="hidden dark:hover:bg-brand-800"></div>
            <div className="hidden dark:hover:bg-brand-900"></div>
            <div className="hidden dark:hover:bg-gray-50"></div>
            <div className="hidden dark:hover:bg-gray-100"></div>
            <div className="hidden dark:hover:bg-gray-200"></div>
            <div className="hidden dark:hover:bg-gray-300"></div>
            <div className="hidden dark:hover:bg-gray-400"></div>
            <div className="hidden dark:hover:bg-gray-500"></div>
            <div className="hidden dark:hover:bg-gray-600"></div>
            <div className="hidden dark:hover:bg-gray-700"></div>
            <div className="hidden dark:hover:bg-gray-800"></div>
            <div className="hidden dark:hover:bg-gray-900"></div>
            <div className="hidden dark:hover:bg-navy-50"></div>
            <div className="hidden dark:hover:bg-navy-100"></div>
            <div className="hidden dark:hover:bg-navy-200"></div>
            <div className="hidden dark:hover:bg-navy-300"></div>
            <div className="hidden dark:hover:bg-navy-400"></div>
            <div className="hidden dark:hover:bg-navy-500"></div>
            <div className="hidden dark:hover:bg-navy-600"></div>
            <div className="hidden dark:hover:bg-navy-700"></div>
            <div className="hidden dark:hover:bg-navy-800"></div>
            <div className="hidden dark:hover:bg-navy-900"></div>
            <div className="hidden dark:hover:bg-red-50"></div>
            <div className="hidden dark:hover:bg-red-100"></div>
            <div className="hidden dark:hover:bg-red-200"></div>
            <div className="hidden dark:hover:bg-red-300"></div>
            <div className="hidden dark:hover:bg-red-400"></div>
            <div className="hidden dark:hover:bg-red-500"></div>
            <div className="hidden dark:hover:bg-red-600"></div>
            <div className="hidden dark:hover:bg-red-700"></div>
            <div className="hidden dark:hover:bg-red-800"></div>
            <div className="hidden dark:hover:bg-red-900"></div>
            <div className="hidden dark:hover:bg-orange-50"></div>
            <div className="hidden dark:hover:bg-orange-100"></div>
            <div className="hidden dark:hover:bg-orange-200"></div>
            <div className="hidden dark:hover:bg-orange-300"></div>
            <div className="hidden dark:hover:bg-orange-400"></div>
            <div className="hidden dark:hover:bg-orange-500"></div>
            <div className="hidden dark:hover:bg-orange-600"></div>
            <div className="hidden dark:hover:bg-orange-700"></div>
            <div className="hidden dark:hover:bg-orange-800"></div>
            <div className="hidden dark:hover:bg-orange-900"></div>
            <div className="hidden dark:hover:bg-amber-50"></div>
            <div className="hidden dark:hover:bg-amber-100"></div>
            <div className="hidden dark:hover:bg-amber-200"></div>
            <div className="hidden dark:hover:bg-amber-300"></div>
            <div className="hidden dark:hover:bg-amber-400"></div>
            <div className="hidden dark:hover:bg-amber-500"></div>
            <div className="hidden dark:hover:bg-amber-600"></div>
            <div className="hidden dark:hover:bg-amber-700"></div>
            <div className="hidden dark:hover:bg-amber-800"></div>
            <div className="hidden dark:hover:bg-amber-900"></div>
            <div className="hidden dark:hover:bg-yellow-50"></div>
            <div className="hidden dark:hover:bg-yellow-100"></div>
            <div className="hidden dark:hover:bg-yellow-200"></div>
            <div className="hidden dark:hover:bg-yellow-300"></div>
            <div className="hidden dark:hover:bg-yellow-400"></div>
            <div className="hidden dark:hover:bg-yellow-500"></div>
            <div className="hidden dark:hover:bg-yellow-600"></div>
            <div className="hidden dark:hover:bg-yellow-700"></div>
            <div className="hidden dark:hover:bg-yellow-800"></div>
            <div className="hidden dark:hover:bg-yellow-900"></div>
            <div className="hidden dark:hover:bg-lime-50"></div>
            <div className="hidden dark:hover:bg-lime-100"></div>
            <div className="hidden dark:hover:bg-lime-200"></div>
            <div className="hidden dark:hover:bg-lime-300"></div>
            <div className="hidden dark:hover:bg-lime-400"></div>
            <div className="hidden dark:hover:bg-lime-500"></div>
            <div className="hidden dark:hover:bg-lime-600"></div>
            <div className="hidden dark:hover:bg-lime-700"></div>
            <div className="hidden dark:hover:bg-lime-800"></div>
            <div className="hidden dark:hover:bg-lime-900"></div>
            <div className="hidden dark:hover:bg-green-50"></div>
            <div className="hidden dark:hover:bg-green-100"></div>
            <div className="hidden dark:hover:bg-green-200"></div>
            <div className="hidden dark:hover:bg-green-300"></div>
            <div className="hidden dark:hover:bg-green-400"></div>
            <div className="hidden dark:hover:bg-green-500"></div>
            <div className="hidden dark:hover:bg-green-600"></div>
            <div className="hidden dark:hover:bg-green-700"></div>
            <div className="hidden dark:hover:bg-green-800"></div>
            <div className="hidden dark:hover:bg-green-900"></div>
            <div className="hidden dark:hover:bg-teal-50"></div>
            <div className="hidden dark:hover:bg-teal-100"></div>
            <div className="hidden dark:hover:bg-teal-200"></div>
            <div className="hidden dark:hover:bg-teal-300"></div>
            <div className="hidden dark:hover:bg-teal-400"></div>
            <div className="hidden dark:hover:bg-teal-500"></div>
            <div className="hidden dark:hover:bg-teal-600"></div>
            <div className="hidden dark:hover:bg-teal-700"></div>
            <div className="hidden dark:hover:bg-teal-800"></div>
            <div className="hidden dark:hover:bg-teal-900"></div>
            <div className="hidden dark:hover:bg-cyan-50"></div>
            <div className="hidden dark:hover:bg-cyan-100"></div>
            <div className="hidden dark:hover:bg-cyan-200"></div>
            <div className="hidden dark:hover:bg-cyan-300"></div>
            <div className="hidden dark:hover:bg-cyan-400"></div>
            <div className="hidden dark:hover:bg-cyan-500"></div>
            <div className="hidden dark:hover:bg-cyan-600"></div>
            <div className="hidden dark:hover:bg-cyan-700"></div>
            <div className="hidden dark:hover:bg-cyan-800"></div>
            <div className="hidden dark:hover:bg-cyan-900"></div>
            <div className="hidden dark:hover:bg-blue-50"></div>
            <div className="hidden dark:hover:bg-blue-100"></div>
            <div className="hidden dark:hover:bg-blue-200"></div>
            <div className="hidden dark:hover:bg-blue-300"></div>
            <div className="hidden dark:hover:bg-blue-400"></div>
            <div className="hidden dark:hover:bg-blue-500"></div>
            <div className="hidden dark:hover:bg-blue-600"></div>
            <div className="hidden dark:hover:bg-blue-700"></div>
            <div className="hidden dark:hover:bg-blue-800"></div>
            <div className="hidden dark:hover:bg-blue-900"></div>
            <div className="hidden dark:hover:bg-indigo-50"></div>
            <div className="hidden dark:hover:bg-indigo-100"></div>
            <div className="hidden dark:hover:bg-indigo-200"></div>
            <div className="hidden dark:hover:bg-indigo-300"></div>
            <div className="hidden dark:hover:bg-indigo-400"></div>
            <div className="hidden dark:hover:bg-indigo-500"></div>
            <div className="hidden dark:hover:bg-indigo-600"></div>
            <div className="hidden dark:hover:bg-indigo-700"></div>
            <div className="hidden dark:hover:bg-indigo-800"></div>
            <div className="hidden dark:hover:bg-indigo-900"></div>
            <div className="hidden dark:hover:bg-purple-50"></div>
            <div className="hidden dark:hover:bg-purple-100"></div>
            <div className="hidden dark:hover:bg-purple-200"></div>
            <div className="hidden dark:hover:bg-purple-300"></div>
            <div className="hidden dark:hover:bg-purple-400"></div>
            <div className="hidden dark:hover:bg-purple-500"></div>
            <div className="hidden dark:hover:bg-purple-600"></div>
            <div className="hidden dark:hover:bg-purple-700"></div>
            <div className="hidden dark:hover:bg-purple-800"></div>
            <div className="hidden dark:hover:bg-purple-900"></div>
            <div className="hidden dark:hover:bg-pink-50"></div>
            <div className="hidden dark:hover:bg-pink-100"></div>
            <div className="hidden dark:hover:bg-pink-200"></div>
            <div className="hidden dark:hover:bg-pink-300"></div>
            <div className="hidden dark:hover:bg-pink-400"></div>
            <div className="hidden dark:hover:bg-pink-500"></div>
            <div className="hidden dark:hover:bg-pink-600"></div>
            <div className="hidden dark:hover:bg-pink-700"></div>
            <div className="hidden dark:hover:bg-pink-800"></div>
            <div className="hidden dark:hover:bg-pink-900"></div>
        </div>
    );


    return shouldInclude
           ? (renderSafeList())
           : (<></>);

};

export default memo(TailwindCssSafeList);
